export default [
  {
    path: "/empresas/:id/centro-custo",
    name: "Empresas Centro Custo",
    component: () => import("../index"),
    meta: { requiresAuth: true },
  },
];
